// extracted by mini-css-extract-plugin
module.exports = {"imageNavPc":"components_imageNavPc__20ysf","textNavPc":"components_textNavPc__E9QCo","secondTitle":"components_secondTitle__YRmMP","thirdItem":"components_thirdItem__sNrws","dropdownRightContainer":"components_dropdownRightContainer__ywqqV"};
module.exports.__checksum = "8966bb8589ab"
